module.exports = __webpack_public_path__ + "img/c465f465-3d45-4e42-87cc-14e5564dc927.2c9bbacc.png";